import React, { createContext, useContext, useEffect, useState } from 'react';
import Pepes from './pepes';
import localStorage from '../../utils/localStorage';

interface IPepe {
  activate: () => void;
}

// @ts-ignore
const PepeContext = createContext<IPepe>();

interface Props {
  children: React.ReactNode;
}

export const PepeContextProvider = ({ children }: Props) => {
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    if (localStorage.isPepeEnabled()) {
      setActivated(true);
    }
  }, []);

  const activate = () => {
    setActivated(true);
    localStorage.enablePepe();
  };

  return (
    <PepeContext.Provider value={{ activate }}>
      {activated ? <Pepes /> : children}
    </PepeContext.Provider>
  );
};

const usePepe = () => useContext(PepeContext);

export default usePepe;
